import React from "react";
import HubShell from "../../Components/Common/HubShell";
import TransactionsPage from "../Transactions";
import PaybisTransactionsPage from "../PaybisTransactions";
import Fees from "../Fees";

document.title = "Money | BiorGov Admin";

// Transactions ledger + Paybis ramp + swap-fee analytics, merged into one hub.
const TABS = [
  { id: "transactions", label: "Transactions", icon: "ri-exchange-dollar-line", perm: "transactions.view", render: () => <TransactionsPage embedded /> },
  { id: "paybis",       label: "Paybis Ramp",  icon: "ri-bank-line",            perm: "paybis.view",        render: () => <PaybisTransactionsPage embedded /> },
  { id: "fees",         label: "Fees",         icon: "ri-coins-line",           perm: "fees.view",          render: () => <Fees embedded view="fees" /> },
  { id: "analytics",    label: "Analytics",    icon: "ri-bar-chart-2-line",     perm: "fees.view",          render: () => <Fees embedded view="analytics" /> },
];

const Money = () => <HubShell title="Money" pageTitle="Operations" tabs={TABS} />;

export default Money;
